const BASE_URL = (process.env.REACT_APP_BASE_URL || "").replace(/\/?$/, "/");
const API = "api/";
const IMAGES_PREFIX = "images/";
const WEB_STATE = process.env.REACT_APP_WEB_STATE;
const HEALTHCHECK_INDEX = process.env.REACT_APP_HEALTHCHECK_INDEX;
const LOGIN_NAME = process.env.REACT_APP_LOGIN_NAME;

export { BASE_URL, API, WEB_STATE, LOGIN_NAME, HEALTHCHECK_INDEX, IMAGES_PREFIX };
